export const getLocalStorageValue = (key: string): any | string | null => {
  const value = localStorage.getItem(key);

  return value ? JSON.parse(value) : null;
};
